export default "__VITE_ASSET__DGvTdYkf__"